import enterprise from "#resources/api/enterprise-client";
import { fetchModel } from "#resources/helpers/fetch-model";
import { RootStore } from ".";

import { showErrorNotification } from "#helpers/notifications";
import { BarModel, barWithPlaceId } from "#models/bar";
import { Bar } from "#resources/api/enterprise-generated";
import { observable } from "mobx";

export class BarStore {
	@observable
	public bars: BarModel[] = [];

	public rootStore: RootStore;

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore;
	}

	public clean() {
		this.bars = [];
	}

	public resolve = (...incomingBars: barWithPlaceId[]) => {
		for (const incomingBar of incomingBars) {
			const bar = this.bars.find(t => t.id === incomingBar.id);
			if (!bar) {
				this.bars = this.bars.concat(new BarModel(this, incomingBar));
			} else {
				bar.sync(incomingBar);
			}
		}

		return this.bars;
	};

	public getBars = new fetchModel<
		{
			placeId: string;
			includeDeleted?: boolean | null;
		},
		Bar[]
	>({
		fnPromise: args => enterprise.getBars(args),
		onError: err => showErrorNotification(err.message),
	});
}
